import { CDN_URL } from '../vars'

export const ICON_MATCHING_TIME_FIRST = `${CDN_URL}/new-theme/icon/matching/time-first.svg`
export const ICON_MATCHING_TUTOR_FIRST = `${CDN_URL}/new-theme/icon/matching/tutor-first.svg`
export const AVATAR_IMAGE = `${CDN_URL}/new-theme/icon/user_image.svg`
